<button class="app-button -option-{{ option }} -{{ color }} -size-{{ size }}" [ngClass]="{'-disabled': disabled}" [type]="type"
  (click)="onButtonClick($event)" [disabled]="disabled">
  <div class="btn-container" matTooltip="{{ tooltip ?? label }}" [matTooltipPosition]="'above'">
    <ng-container [ngSwitch]="option">
      <ng-container *ngSwitchCase="BUTTON_OPTION?.BASIC">
        <span class="label" *ngIf="label && labelPosition === BUTTON_LABEL_POSITION?.PREFIX">{{ label }}</span>
        <span *ngIf="icon" class="icon-container" [class.has-hover-icon]="hoverIcon">
          <img *ngIf="hoverIcon" class="hover-icon -icon-color-{{ iconColor }}" src="../../../../assets/images/{{ hoverIcon }}" alt="{{ label }}" />
          <img class="icon -icon-color-{{ iconColor }}" src="../../../../assets/images/{{ icon }}" alt="{{ label }}" />
        </span>
        <span class="label" *ngIf="label && labelPosition === BUTTON_LABEL_POSITION?.SUFFIX">{{ label }}</span>
      </ng-container>
      <ng-container *ngSwitchCase="BUTTON_OPTION?.ICON">
        <span *ngIf="icon" class="icon-container" [class.has-hover-icon]="hoverIcon">
          <img *ngIf="hoverIcon" class="hover-icon -icon-color-{{ iconColor }}" src="../../../../assets/images/{{ hoverIcon }}" alt="{{ label }}"
            [style.width.px]="iconSize ?? 'unset'" />
          <img class="icon -icon-color-{{ iconColor }}" src="../../../../assets/images/{{ icon }}" alt="{{ label }}"
            [style.width.px]="iconSize ?? 'unset'" />
        </span>
      </ng-container>
    </ng-container>
  </div>
</button>